import { getAiApiUrl } from '../../config';

interface FeedbackRequest {
  walletAddress: string;
  nonce: string;
  user: string;
  rating: 'like' | 'dislike' | 'neutral';
  content?: string;
}

export const createFeedback = async (
  auth: { jwt: string; walletAddress: string; nonce: string, did: string },
  messageId: string,
  data: FeedbackRequest
): Promise<{ success: boolean }> => {
  const response = await fetch(`${getAiApiUrl()}/messages/${messageId}/feedbacks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth.jwt}`
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to submit feedback');
  }

  return response.json();
};
